import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Moon, Sun1, Import, Menu, HambergerMenu } from "iconsax-react";
import { useThemeProvider } from "../../providers/ThemeProvider";
import { useLanguageProvider } from "../../providers/LanguageProvider";
import { LinkValues } from "../../values/strings";
import LanguageSelectorDialogComponent from "../dialogs/LanguageDialogComponent";
import { MainDrawerComponent } from "../drawers/MainDrawerComponent";
import { MainDrawerListViewComponent } from "../listview/DrawerListViewComponent";

const MainAppBarComponent = () => {
  const theme = useThemeProvider();
  const lang = useLanguageProvider();
  const { t, i18n } = useTranslation();
  const [langMenuAnchorEl, setLangMenuAnchorEl] = React.useState(null);
  const isLangMenuOpen = Boolean(langMenuAnchorEl);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleChangeTheme = () => {
    theme.setTheme(
      theme.theme.palette.mode == "dark"
        ? theme.styles.light
        : theme.styles.dark
    );
  };

  const handleOpenMenu = () => {
    setIsOpen(true);
  };

  const startItems = () => (
    <Grid
      container
      item
      diraction={"row"}
      xs={6}
      alignContent="center"
      justifyContent={{ md: "flex-start", xs: "flex-end" }}
    >
      <Grid
        container
        item
        diraction={"row"}
        xs={"auto"}
        alignContent="center"
        justifyContent="flex-start"
      >
        <a
          href={LinkValues.routes.initLocale(
            LinkValues.routes.base(false),
            lang.supportedLanguages
          )}
        >
          <img
            src={LinkValues.images.icons.navHeaderLight()}
            hidden={theme.theme.palette.mode != "light"}
          />
          <img
            src={LinkValues.images.icons.navHeaderDark()}
            hidden={theme.theme.palette.mode != "dark"}
          />
        </a>
      </Grid>
      <Grid
        container
        item
        diraction={"row"}
        md
        display={{ md: "flex", xs: "none" }}
        alignContent="center"
        justifyContent="flex-start"
      >
        <Box paddingLeft={2}></Box>
        <Button
          color={"textButton"}
          LinkComponent={"a"}
          href={LinkValues.routes.initLocale(
            LinkValues.routes.market.self(false),
            lang.supportedLanguages
          )}
          disableRipple
        >
          <Typography variant="navBar">{t("markets")}</Typography>
        </Button>
        {/* <Box paddingLeft={1}></Box>
        <Button
          color={"textButton"}
          LinkComponent={"a"}
          href={LinkValues.routes.initLocale(
            LinkValues.routes.trade.self(false),
            lang.supportedLanguages
          )}
          disableRipple
        >
          <Typography variant="navBar">{t("buysell")}</Typography>
        </Button> 
        <Box paddingLeft={1}></Box>
        <Button
          color={"textButton"}
          LinkComponent={"a"}
          href={LinkValues.routes.initLocale(
            LinkValues.routes.wallet.self(false),
            lang.supportedLanguages
          )}
          disableRipple
        >
          <Typography variant="navBar">{t("wallet")}</Typography>
        </Button>
        <Box paddingLeft={1}></Box>
        <Button
          color={"textButton"}
          LinkComponent={"a"}
          href={LinkValues.routes.initLocale(
            LinkValues.routes.earn.self(false),
            lang.supportedLanguages
          )}
          disableRipple
        >
          <Typography variant="navBar">{t("earn")}</Typography>
        </Button>*/}
        <Box paddingLeft={1}></Box>
        <Button
          color={"textButton"}
          LinkComponent={"a"}
          href={LinkValues.routes.initLocale(
            LinkValues.routes.about.self(false),
            lang.supportedLanguages
          )}
          disableRipple
        >
          <Typography variant="navBar">{t("about")}</Typography>
        </Button>
      </Grid>
    </Grid>
  );

  const endMdItems = () => (
    <Grid
      container
      item
      diraction={"row"}
      md={6}
      xs={0}
      display={{ md: "flex", xs: "none" }}
      alignContent="center"
      justifyContent="flex-end"
    >
      <Button
        color={"textButton"}
        disableRipple
        href={LinkValues.routes.initLocale(
          LinkValues.routes.auth.login(false),
          lang.supportedLanguages
        )}
      >
        <Typography variant="navBar">{t("log_in")}</Typography>
      </Button>
      <Box paddingLeft={1}></Box>
      <Button
        color={"primary"}
        variant="contained"
        disableElevation
        disableRipple
        href={LinkValues.routes.initLocale(
          LinkValues.routes.auth.register(false),
          lang.supportedLanguages
        )}
      >
        <Typography variant="navBar">{t("sign_up")}</Typography>
      </Button>
      <Box paddingLeft={1}></Box>
      {/* <IconButton
      underline="none"
      color={"textButton"}
      disableRipple
      onClick={handleChangeTheme}
    >
      <Import size={20} />
    </IconButton> */}
      <Box paddingLeft={1}></Box>
      <Button
        color={"textButton"}
        disableRipple
        onClick={() => setIsLanguageMenuOpen(true)}
      >
        <Typography variant="navBar">
          {t(`lang_${i18n.resolvedLanguage}_name`)}
        </Typography>
      </Button>
      <LanguageSelectorDialogComponent
        isOpen={isLanguageMenuOpen}
        onClose={() => setIsLanguageMenuOpen(false)}
      />
      <Box paddingLeft={1}></Box>
      <IconButton
        underline="none"
        color={"textButton"}
        disableRipple
        onClick={handleChangeTheme}
      >
        {(theme.theme.palette.mode === "dark" && <Sun1 size={17} />) || (
          <Moon size={17} />
        )}
      </IconButton>
    </Grid>
  );

  const endXsItems = () => (
    <Grid
      container
      item
      diraction={"row"}
      md={0}
      xs={6}
      display={{ md: "none", xs: "flex" }}
      alignContent="center"
      justifyContent="flex-start"
    >
      <IconButton
        underline="none"
        color={"textButton"}
        disableRipple
        onClick={handleOpenMenu}
      >
        <HambergerMenu />
      </IconButton>
    </Grid>
  );

  return (
    <Box sx={{ flexGrow: 1 }} height={79}>
      <AppBar
        position="fixed"
        elevation={0}
        color={"theme"}
        className={theme.styles.classes.componentsNavbar}
      >
        <Box className={theme.styles.classes.appbarBox}>
          <Grid container alignContent="center">
            {endXsItems()}
            {startItems()}
            {endMdItems()}
          </Grid>
        </Box>
      </AppBar>
      <MainDrawerComponent
        anchor={lang.textDirection() === "ltr" ? "left" : "right"}
        isOpen={isOpen}
        onClose={(isOpen) => setIsOpen(isOpen)}
      >
        <MainDrawerListViewComponent />
      </MainDrawerComponent>
    </Box>
  );
};

export default MainAppBarComponent;
